module.exports = __webpack_public_path__ + "img/1.861e3889.png";